import { takeEvery, all, put, select } from "redux-saga/effects";
import {
    sendSignupAction,
    uploadMappingsForSignup,
    changeSignupSendingFlag,
    changeStatusSignupModalAction
} from "./actions";
import { getIndustriesRequest, getCategoriesRequest, postSignupRequest } from "@common";
import { signupForm } from "./state";
import { AppState } from "../store";
import { openNotificationAction } from "../page";
import { SignupFormData, validateEmail } from "../api";

export function* uploadSignupMappings() {
    try {
        yield all([getIndustriesRequest.saga({}), getCategoriesRequest.saga({})]);
    } catch (e) {
        console.log(e);
    }
}

function* sendSignup() {
    yield put(signupForm.actions.resetErrors());
    const state: AppState = yield select();
    const signupFormData = signupForm.selector(state.signupState.signupForm);

    if (!signupFormData.isValid || !validateEmail(signupFormData.fields.email.value)) {
        yield put(signupForm.actions.validate());
        yield put(
            openNotificationAction({
                isOpen: true,
                isWarning: true,
                message: "Validation error! Please, check your form"
            })
        );

        return;
    }

    try {
        yield put(changeStatusSignupModalAction({ isOpen: false }));
        yield put(changeSignupSendingFlag({ status: true }));

        const signupData: SignupFormData = {
            name: signupFormData.data.name,
            email: signupFormData.data.email,
            category: signupFormData.data.category,
            industry: signupFormData.data.industry
        };

        yield* postSignupRequest.saga({}, signupData);

        yield put(
            openNotificationAction({
                isOpen: true,
                message: "Signup newsletter was sent!"
            })
        );
        yield put(changeSignupSendingFlag({ status: false }));
    } catch (e) {
        console.log(e);
        yield put(
            openNotificationAction({
                isOpen: true,
                isWarning: true,
                message: "Signup newsletter didn't send! Please, try later!"
            })
        );
        yield put(changeSignupSendingFlag({ status: false }));
    }
}

export function* signupSaga() {
    yield all([
        takeEvery(uploadMappingsForSignup.type, uploadSignupMappings),
        takeEvery(sendSignupAction.type, sendSignup)
    ]);
}
